export default "__VITE_ASSET__C40H4qTU__"